module.exports = __webpack_public_path__ + "img/ci.1181db19.svg";